



























































import {
  apiEvaluationEvaluateSubmit,
  apiOrderWriteOffOrderDetail,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { navigateBack } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '评价',
        }))
      }

      query = useQuery<{
        orderNo: string
      }>()

      apiData = useApi(() =>
        apiOrderWriteOffOrderDetail({
          orderNo: this.query.orderNo,
        }),
      )

      pageData = computed(() => this.apiData.data)

      rate = ref(0)

      message = ref('')

      images = ref<string[]>([])

      handleRateClick = (n: number) => {
        this.rate.value = n
      }

      handlePublishClick = () => {
        submit(async $ => {
          if (this.rate.value === 0) {
            return $.fail('请填写评分')
          }
          $.start('评价中...')
          await apiEvaluationEvaluateSubmit({
            list: [
              {
                paySerialNo: '',
                refOrderNo: this.pageData.value.orderNo!,
                merchantName: this.pageData.value.merchantName!,
                commodityServiceId: this.pageData.value.commodityId!,
                commodityServiceName: this.pageData.value.commodityName!,
                commodityServiceSpecs: '默认',
                orderAmount: this.pageData.value.orderAmount!,
                label: '',
                evaluateStar: this.rate.value,
                evaluateContent: this.message.value,
                evaluatePic: this.images.value,
              },
            ],
          })
          await $.success('评价成功')
          navigateBack()
        })
      }
    },
)
